import * as types from '../constants/commonConstants';
import { API_URL , FWD_API_URL , IS_ENABLE_RSA } from './../constants/index';
const { detect } = require('detect-browser');
const browser = detect();
const browserName = browser.name;
const browserVersion = browser.version;

export class CommonActions {

  static httpAction(action) {//console.log("httpAction "+ JSON.stringify(action));
    const httpActionTemplate = {
      type: "",
      endpoint: null,
      verb: "",
      response: null,
      headers: {}
    };

    return {
      HTTP_ACTION: Object.assign({}, httpActionTemplate, action)
    };
  }

  static handleAPICall(apiParams, apiName, apiType, actionType, states) {//console.log("apiName "+apiName);
    const platform = localStorage.getItem('platform');
    if (apiName === '/restlogin') {
      let response, user;
       if (!IS_ENABLE_RSA) {
         response = JSON.stringify(apiParams);
         user = apiParams;
       } else {
         response = apiParams.encryptedData;
         user = states;// user details are required in middleware to store in reducer on login success
	       }
      return CommonActions.httpAction({
        type: apiType,
        verb: actionType,
        endpoint: API_URL + apiName,
        response: response,
        user: user,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Cache-Control": "no-cache",
          "platform": platform,
          "X-Encrypted": (IS_ENABLE_RSA ? true : false)
        }
      });
    } else {
      var user = JSON.parse(localStorage.getItem('user'));
      const location = localStorage.getItem('location');
      let url;
      // if (apiName === '/trader/chart' || apiName === '/trader/candleStickChart' || apiName === '/trader/historicalChart') { //console.log("chart api call ");
      //   url = MONGOAPIPATH + '/user' + apiName + '?' + apiParams;// All chart api call has GET method.
      // } else
      const apiNames = ['/restlogin','/resetPwd','/acceptTerm','/declineTerm','/fwdDealRequest','/getTenors','/getAccLocShrtnameAndCode','/swapDealRequest'];
      if (!apiNames.includes(apiName)) {
        apiName = '/user' + apiName;
        if (actionType === 'POST') {
          url = API_URL + apiName;
        } else {
          url = API_URL + apiName + '?' + apiParams;
        }
      } else if (apiName === '/fwdDealRequest'){
        apiName = '/forward/user' + apiName;
        if (actionType === 'POST') {
          url = FWD_API_URL + apiName;
        } else {
          url = FWD_API_URL + apiName + '?' + apiParams;
        }
      } else if (apiName === '/swapDealRequest'){
        apiName = '/swap/user' + apiName;
        if (actionType === 'POST') {
          url = FWD_API_URL + apiName;
        } else {
          url = FWD_API_URL + apiName + '?' + apiParams;
        }
      } else if (apiName ==='/getTenors'){
        apiName = '/forward/user' + apiName;
        if (actionType === 'POST') {
          url = FWD_API_URL + apiName;
        } else {
          url = `${FWD_API_URL + apiName}?iid=${apiParams?.updatedCmdtyPair}&date=${apiParams?.updatedFixingDate}`;
        }
      } else if (apiName ==='/getAccLocShrtnameAndCode'){
        apiName = '/swap/user' + apiName;
        if (actionType === 'POST') {
          url = FWD_API_URL + apiName;
        } 
      } else {
        if (actionType === 'POST') {
          url = API_URL + apiName;
        } else {
          url = API_URL + apiName + '?' + apiParams;
        }
      }
      return CommonActions.httpAction({
        type: apiType,
        verb: actionType,
        endpoint: url,
        response: JSON.stringify(apiParams),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Cache-Control": "no-cache",
          "sid": user.sid,
          "username": user.id,
          "location": location,
          "platform": platform,
          "x-auth": user.authToken

        },
        initialStates: states
      });
    }
  }

  // Auth
  static isLoaded(globalState) {
    return globalState.auth && globalState.auth.loaded;
  }

  static showLoadingIndicator() {
    return {
      type: types.LOADING_ON
    };
  }

  static stopLoadingIndicator() {
    return {
      type: types.LOADING_OFF
    };
  }

  // Set theme for widgets
  static setWidgetTheme(value) {
    return {
      types: [types.WIDGET_THEMING_SUCCESS, types.WIDGET_THEMING_FAILURE],
      promise: (client) => client.post('/widget_color', {
        data: { value }
      }),
      value
    };
  }

  static getWidgetTheme(theme) {
    return {
      types: [types.GET_WIDGET_THEMING, types.GET_WIDGET_THEMING_SUCCESS, types.GET_WIDGET_THEMING_FAILURE],
      promise: (client) => client.get('/widget_color', {
        themePreview: theme
      })
    };
  }

  // Handle popup
  static handleModal(status) {
    return {
      type: types.HANDLE_MODAL,
      status
    };
  }
  static closeforcedModal() {
    return {
      type: types.CL_FORCED_LOGOUT
    }
  }


  // Hide the dialog
  static hideDialog() {
    return {
      type: types.HIDE_DIALOG,
    };
  }

  // To toggle between trade and report
  static navigationTradeReport(option) {
    return {
      type: types.NAVIGATE_TRADE_REPORT,
      option
    };
  }

  //Handle popouts
  static popupwindowHandle(open, key) {
    return {
      type: types.POPUP_WINDOW_HANDLE,
      opened: open,
      key
    };
  }
  // Handle popouts
  static popinWidget(key) {
    return {
      type: types.POPUPCLOSE_HANDLE,
      key
    };
  }
  static setSessionKillFlag(key) {
    var msg = "";
    return {
      type: types.KILL_SESSION,
      key, msg
    };
  }
  static loadLockFlag(flag) {
    //alert("in common action flag is "+flag);
    return {
      type: types.LOAD_LOCK_FLAG,
      flag
    };
  }
  static onClickCalender(flag, keyValue) {
    return {
      type: types.CHANGE_CALENDAR_FLAG,
      flag, keyValue
    }
  }
  static logFileCreation(errorObj) {
    return {
      type: types.LOG_FILE_CREATE,
      errorObj
    }
  }

  static sendErrorLogs(err) {
    const user = JSON.parse(localStorage.getItem('TS'));
    const platform = localStorage.getItem('platform');
    var data = {
      UserDetails: { SID: user.SID, UDES: user.UDES, UID: user.UID, Platform: platform, Browser: browserName, BrowserVersion: browserVersion },
      errDetails: err
    }
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall(data, '/errorLog', types.SEND_LOG, 'POST'));
    };
  }

  //NontradedStock List api
  static getNonTradedStock() {
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall('', '/NonTrdCmdty', types.GET_NONTRADEDSTK_LIST, 'GET'));
    };
  }

  // Reset Password flag
  static resetPassFlag() {
    return {
      type: types.RESET_PASSWORD_FLAG
    };
}

}

//NontradedStock List api
export function getNonTradedStock() {
  return {
    types: [
      types.GET_NONTRADEDSTK_LIST, types.GET_NONTRADEDSTK_LIST_SUCCESS, types.GET_NONTRADEDSTK_LIST_FAILURE
    ],
    promise: (client) => client.get(`/NonTrdCmdty`)
  };
}
